export default class TastesEnum {
  static GUEST = 'guest';
  static CLIENT = 'client';
}
